import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
export default {
  name: 'CategoryCatalog',
  props: {
    categories: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    items: function items() {
      var _this = this;

      return this.categories.top.map(function (e) {
        return {
          label: e.label,
          url: _this.buildCategoryUrl(_this.locale, e.slug, e.hash)
        };
      });
    }
  }),
  methods: {
    tracking: function tracking(label) {
      return {
        data: {
          event_category: 'Categorie',
          event_action: "Arbo_".concat(label),
          event_label: "".concat(window.tc_vars.page_cat1, "_").concat(window.tc_vars.page_cat3)
        }
      };
    },
    catalogClick: function catalogClick(event, eventActionLabel) {
      this.$root.$emit('generic-tracking', event, this.tracking(eventActionLabel));
    }
  }
};